<template>
  <div class="contacts-form">
    <form
      v-show="formResult === 'form'"
      @submit.prevent="$_sendForm"
      class="contacts__form">

      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Nome</div>
        <input
          v-model="name"
          :class="{ 'errorinput': errors.has('name')}"
          name="name"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('name') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Cognome</div>
        <input
          v-model="surname"
          :class="{ 'errorinput': errors.has('surname')}"
          name="surname"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('surname') }}</span>
      </div>
      <!--
        <div v-placeholder class="contacts__form__element">
          <div class="contacts__form__element__placeholder">Professione</div>
          <select
            v-model="profession"
            :class="{ 'errorinput': errors.has('profession')}"
            name="profession"
            v-validate="'required'">
            <option key="generale" value="generale">generale</option>
          </select>
          <span class="contacts__form__element_error">{{ errors.first('profession') }}</span>
        </div>
      -->
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Azienda</div>
        <input
          v-model="profession"
          name="profession"
          type="text">
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Città</div>
        <input
          v-model="city"
          :class="{ 'errorinput': errors.has('city')}"
          name="city"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('city') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Email</div>
        <input
          v-model="email"
          :class="{ 'errorinput': errors.has('email')}"
          name="email"
          type="text"
          v-validate="'required|email'">
        <span class="contacts__form__element_error">{{ errors.first('email') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element">
        <div class="contacts__form__element__placeholder">Telefono</div>
        <input
          v-model="telephone"
          :class="{ 'errorinput': errors.has('telephone')}"
          name="telephone"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('telephone') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element contacts__form__element--textarea">
        <div class="contacts__form__element__placeholder">Messaggio</div>
        <input
          v-model="message"
          :class="{ 'errorinput': errors.has('message')}"
          name="message"
          type="text"
          v-validate="'required'">
        <span class="contacts__form__element_error">{{ errors.first('message') }}</span>
      </div>
      <div v-placeholder class="contacts__form__element contacts__form__element--checkbox">
        <div class="custom-checkbox" :class="{ 'errorinput': errors.has('privacy')}">
          <p style="text-decoration: none">
            Ai sensi e per gli effetti degli artt. 7, 12, 13 ss. del Reg. UE 2016/679 - GDPR:
          </p>
          <input v-model="privacy" v-validate="'required'" name="privacy" type="checkbox" id="privacy_check"/>
          <label for="privacy_check">
            dichiaro di aver preso visione della <router-link :to="{ name: 'single-page', params: { slug: 'privacy-policy' } }">Privacy Policy</router-link> per il trattamento dei miei dati personali;</label>
          <span class="contacts__form__element_error">{{ errors.first('privacy') }}</span>
        </div>
        <div class="custom-checkbox">
          <input v-model="newsletter" name="newsletter" type="checkbox" id="newsletter-c"/>
          <label for="newsletter-c">acconsento al trattamento dei miei dati personali per ricevere comunicazioni promozionali / commerciali.</label>
        </div>
      </div>
      <div class="contacts__form__element contacts__form__element--send-button">
        <button :class="{'contacts__form__element--send-button--enabled': buttonEnabled}">Invia richiesta</button>
      </div>
    </form>
    <div
      v-show="formResult === 'success'"
      class="contacts-form__results">
      <h3>Grazie per averci contattato,<br> abbiamo ricevuto la tua richiesta.</h3>
      <p>Ti contatteremo a breve.</p>
    </div>
    <div
      v-show="formResult === 'failure'"
      class="contacts-form__results">
      <h3>Si è verificato un problema<br> durante l'invio del modulo.</h3>
      <p>Contattaci direttamente presso <a href="mailto:info@colorificiopostumia.it">info@colorificiopostumia.it</a>.</p>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import axios from 'axios'
import { load } from 'recaptcha-v3'
import dictionary from '../../validation/dictionary'

export default {
  name: 'ContactsForm',
  data: () => ({
    name: '',
    surname: '',
    profession: '',
    city: '',
    email: '',
    telephone: '',
    message: '',
    privacy: '', // privacy.repeat(20),
    newsletter: false,
    token: '',
    formResult: 'form',
    buttonEnabled: true
  }),
  methods: {
    $_validateBeforeSubmit () {
      this.$validator.localize('en', dictionary)
      return this.$validator.validateAll()
    },
    async $_sendForm () {
      // validate inputs
      const validated = await this.$_validateBeforeSubmit()
      // console.log('VALIDATED: ', validated)
      if (validated) {
        // load recaptcha token
        if (this.buttonEnabled) {
          this.buttonEnabled = false
          const recaptcha = await load('6LfVh7AUAAAAAMEU1HIJOESVZvduvhNo7skfVWT4')
          this.token = await recaptcha.execute('homepage')
          // console.log('TOKEN: ', this.token)
          if (typeof this.token !== 'undefined') {
            const submissionResult = await this.$_post({
              name: this.name,
              surname: this.surname,
              profession: this.profession,
              city: this.city,
              email: this.email,
              telephone: this.telephone,
              message: this.message,
              newsletter: this.newsletter, // boolean,
              token: this.token
            })
            if (submissionResult) this.formResult = 'success' // success
            else this.formResult = 'failure' // failure
          }
          // subscribe to mailchimp
          if (!this.newsletter) return
          this.$_mailchimpSubscribe()
        }
      }
    },
    async $_mailchimpSubscribe () {
      try {
        const list = process.env.VUE_APP_MAILCHIMP_LIST_ID_IT
        const mailchimp = await axios.post(`https://europe-west1-colorificio-postumia.cloudfunctions.net/mailchimp/list/${list}/members/create`,
          {
            emailAddress: this.email,
            status: 'subscribed',
            mergeFields: {
              'FNAME': this.name,
              'LNAME': this.surname,
              'MMERGE5': this.city,
              'PHONE': this.telephone
            }
          }
        )
        if (mailchimp.status === 'pass') return true
        return false
      } catch (err) {
        return false
      }
    },
    async $_post (postData) {
      // recupero la lingua
      var submittedLang = 'it'
      try {
        const validateRecaptcha = await axios.post('https://europe-west1-colorificio-postumia.cloudfunctions.net/recaptcha/validate', {
          fields: {
            title: {
              [submittedLang]: postData.email + ' on ' + new Date().toUTCString()
            },
            name: {
              [submittedLang]: postData.name
            },
            surname: {
              [submittedLang]: postData.surname
            },
            profession: {
              [submittedLang]: postData.profession
            },
            city: {
              [submittedLang]: postData.city
            },
            email: {
              [submittedLang]: postData.email
            },
            telephone: {
              [submittedLang]: postData.telephone
            },
            message: {
              [submittedLang]: postData.message
            },
            newsletter: {
              [submittedLang]: postData.newsletter
            }
          },
          context: {
            token: postData.token,
            model: 'contacts'
          }
        })
        if (validateRecaptcha.data.status === 'pass') return true
        return false
      } catch (err) {
        console.log('validateRecaptcha', err)
        return false
      }
    }
  },
  directives: {
    placeholder: {
      bind (el) {
        el.classList.add('contacts__form__element--show-placeholder')

        const input = el.querySelector('input, select')
        if (input !== null) {
          input.addEventListener('focus', () => {
            el.classList.add('contacts__form__element--hide-placeholder')
          })

          input.addEventListener('blur', () => {
            if (input.value.trim() === '') {
              el.classList.remove('contacts__form__element--hide-placeholder')
            } else {
              el.classList.add('contacts__form__element--hide-placeholder')
            }
          })
        }
      }
    }
  },
  watch: {
    formResult (newVal, oldVal) {
      document.querySelector('html,body').scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
  @import "./forms.scss";
</style>
